/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_V2_Not_StartedInputs */

const en_home_v2_not_started = /** @type {(inputs: Home_V2_Not_StartedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Not started`)
};

const es_home_v2_not_started = /** @type {(inputs: Home_V2_Not_StartedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sin empezar`)
};

/**
* | output |
* | --- |
* | "Not started" |
*
* @param {Home_V2_Not_StartedInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const home_v2_not_started = /** @type {((inputs?: Home_V2_Not_StartedInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_V2_Not_StartedInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_home_v2_not_started(inputs)
	return en_home_v2_not_started(inputs)
});